import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Twitter, Youtube } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gradient-to-b from-black to-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Logo and CTA */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-6">
              <div className="w-8 h-8 bg-gradient-to-br from-green-400 to-green-600 rounded-lg flex items-center justify-center">
                <span className="text-black font-bold text-lg">G</span>
              </div>
              <span className="text-white font-bold text-xl">GERVIS</span>
            </Link>
            <Link to="/demo">
              <Button className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-400 text-white rounded-full px-6 py-2 flex items-center space-x-2 shadow-lg shadow-green-600/30">
                <span>{t.nav.tryGervis}</span>
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>

          {/* Sitemap */}
          <div>
            <h3 className="font-semibold mb-4 text-green-400">{t.footer.sitemap}</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/" className="hover:text-white transition-colors">{t.footer.home}</Link></li>
              <li><Link to="/partners" className="hover:text-white transition-colors">{t.footer.partners}</Link></li>
              <li><Link to="/cases" className="hover:text-white transition-colors">{t.footer.cases}</Link></li>
              <li><Link to="/ai-agents" className="hover:text-white transition-colors">{t.nav.aiAgents}</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">{t.contact.title}</Link></li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="font-semibold mb-4 text-green-400">{t.footer.industries}</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/industries/health" className="hover:text-white transition-colors">{t.footer.health}</Link></li>
              <li><Link to="/industries/realestate" className="hover:text-white transition-colors">{t.footer.realestate}</Link></li>
              <li><Link to="/industries/insurance" className="hover:text-white transition-colors">{t.footer.insurance}</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4 text-green-400">{t.footer.resources}</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/blog" className="hover:text-white transition-colors">{t.footer.blog}</Link></li>
              <li><Link to="/community" className="hover:text-white transition-colors">{t.footer.community}</Link></li>
              <li><Link to="/help" className="hover:text-white transition-colors">{t.footer.helpCenter}</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4 text-green-400">{t.footer.legal}</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/privacy" className="hover:text-white transition-colors">{t.footer.privacy}</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">{t.footer.terms}</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="flex space-x-6 mb-4 md:mb-0">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors">
              <Linkedin className="w-5 h-5" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors">
              <Twitter className="w-5 h-5" />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors">
              <Youtube className="w-5 h-5" />
            </a>
          </div>
          <p className="text-gray-400 text-sm">{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;